module.exports = __webpack_public_path__ + "img/python.9725ef8c.png";